import React from 'react';
import * as styles from '../styles/SweetAlertStyles';
var defaultMessage = 'Please enter a response!';
var emailMessage = 'Please enter a valid email!';
var ValidationMessage = function (_a) {
    var validationMsg = _a.validationMsg, inputType = _a.inputType;
    var message = validationMsg || (inputType === 'email' ? emailMessage : defaultMessage);
    return (React.createElement("div", { style: styles.validationMessage },
        React.createElement("div", { style: styles.exclamationIcon }, "!"),
        message));
};
export default ValidationMessage;
//# sourceMappingURL=ValidationMessage.js.map